// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__OTSkh","controls":"styles_controls__m3Um9","charLimit":"styles_charLimit__20OZy","input":"styles_input__NnHzR","send":"styles_send__2BEH9"};